// extracted by mini-css-extract-plugin
export default {"iframeAIGenerateCase":"IframeAIGenerateCase__iframeAIGenerateCase___VPuUF","aiDialogueWrap":"IframeAIGenerateCase__aiDialogueWrap___DbOGq"};